<template>
  <BittsLoading :is-loading="isLoading">
    <div class="c-shared-with-you-tab">
      <SharedWithYou
        :key="componentKey"
        @open-data-share-request-modal="onRequestData"
      />
      <DataShareRequestModal
        :data-share-request-modal-visible
        :org-ids
        :partner-pops
        @modal-closed="dataShareRequestModalVisible = false"
      />
    </div>
  </BittsLoading>
</template>

<script setup lang="ts">
import { BittsLoading } from '@crossbeam/bitts';

import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

import { useDataSharesStore } from '@/stores';
import { PartnerPopulationWithMetadata } from '@/types/data_share_requests';

import DataShareRequestModal from '../../DataShareRequestModal.vue';
import SharedWithYou from '../../SharedWithYou.vue';

const props = defineProps<{
  partnerId?: number;
  isPropsMode?: boolean;
}>();

const route = useRoute();
const dataSharesStore = useDataSharesStore();

const componentKey = computed(() => {
  if (props.isPropsMode && props.partnerId) {
    return `partner_${props.partnerId}__shared_with_you`;
  }
  return `${route.fullPath}__shared_with_you`;
});

const isLoading = computed(() => !dataSharesStore.ready);
const dataShareRequestModalVisible = ref(false);
const orgIds = ref<number[]>([]);
const partnerPops = ref<Record<number, PartnerPopulationWithMetadata[]>>({});

function onRequestData({
  orgId,
  partnerPop,
}: {
  orgId: number;
  partnerPop: PartnerPopulationWithMetadata;
}) {
  dataShareRequestModalVisible.value = true;
  orgIds.value = [orgId];
  partnerPops.value = { [orgId]: [partnerPop] };
}
</script>

<style lang="pcss" scoped>
@reference "../../../../css/theme.css";
.c-shared-with-you-tab {
  @apply flex flex-col m-24 gap-20;
}
</style>
